import type { RootState } from "@src/store/rootState";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { getEmbeddedNodesFactory } from "@src/store/slices/experienceBuilder/common/selectors/getEmbeddedNodesFactory";

export const getEmbeddedNodeFactory = (mod: EmbeddedMod) => {
  const getEmbeddedNodes = getEmbeddedNodesFactory(mod);
  return (state: RootState) => {
    const nodes = getEmbeddedNodes(state);
    if (!("selector" in mod)) {
      return undefined;
    }

    return nodes.find((n) => n.selector === mod.selector);
  };
};
